module.exports = __webpack_public_path__ + "img/image-slider-03.4e6f1fee.jpg";